import { MemberEditRequest } from '../models/ss-api/requests/member.edit.request';
import { MemberDetailsDialog } from '../dialogs/member.details/member.details.dialog';
import { Member } from '../models/domain/member';

import { ManagerBase } from './manager.base';


export class MemberManager extends ManagerBase<Member> {


    constructor(id: number = 0, showAfterLoad: boolean = true) {
        super();

        if (id != 0)
            this.Load(id, showAfterLoad);

    }


    public Member(): Member {
        return this.newEntity;
    }


    public FirstNameEdited(): boolean {
        return this.original.FirstName != this.newEntity.FirstName;
    }

    public LastNameEdited(): boolean {
        return this.original.LastName != this.newEntity.LastName;
    }

    public CompanyNameEdited(): boolean {
        return this.original.CompanyName != this.newEntity.CompanyName;
    }

    public EmailEdited(): boolean {
        return this.original.Email != this.newEntity.Email;
	}
	
	public PreventAutomatedEmailEdited(): boolean {
        return this.original.PreventAutomaticEmails != this.newEntity.PreventAutomaticEmails;
	}
	
	public ExemptFromTaxEdited(): boolean {
        return this.original.ExemptFromTax != this.newEntity.ExemptFromTax;
	}

    public Phone1Edited(): boolean {
        let originalPhone1 = this.original.Phone1;
        let newPhone1 = this.newEntity.Phone1;

        if (originalPhone1 == null){
            originalPhone1 = "";
        }

        if (newPhone1 == null){
            newPhone1 = "";
        }

        return originalPhone1 != newPhone1.replace(/[^\d]/g, "");
    }

    public Phone2Edited(): boolean {
        let originalPhone2 = this.original.Phone2;
        let newPhone2 = this.newEntity.Phone2;

        if (originalPhone2 == null){
            originalPhone2 = "";
        }

        if (newPhone2 == null){
            newPhone2 = "";
        }

        return originalPhone2 != newPhone2.replace(/[^\d]/g, "");
    }

    public FaxEdited(): boolean {
        return this.original.Fax != this.newEntity.Fax;
    }

    public Address1Edited(): boolean {
        return this.original.Address1 != this.newEntity.Address1;
    }

    public CityEdited(): boolean {
        return this.original.City != this.newEntity.City;
    }

    public HubspotVIDEdited(): boolean {
        return this.original.HubspotVID != this.newEntity.HubspotVID;
    }

    public StateEdited(): boolean {
        return this.original.State != this.newEntity.State;
    }

    public CountryEdited(): boolean {
        return this.original.Country != this.newEntity.Country;
    }

    public ZipCodeEdited(): boolean {
        return this.original.ZipCode != this.newEntity.ZipCode;
    }

    public LifeCycleStageEdited(): boolean {
        return this.original.LifeCycleStage != this.newEntity.LifeCycleStage;
    }

    public DefaultPayMethodEdited(): boolean {
        return this.original.DefaultPayMethod != this.newEntity.DefaultPayMethod;
    }

    public StatusEdited(): boolean {
        return this.original.Status != this.newEntity.Status;
    }

    public AdminNoteEdited(): boolean {
        return this.original.AdminNote != this.newEntity.AdminNote;
    }

    public PasswordEdited(): boolean {
        return this.original.Password != this.newEntity.Password;
    }

    public AuthorizedContactFirstNameEdited(): boolean {
        return this.original.AuthorizedContactFirstName != this.newEntity.AuthorizedContactFirstName;
    }

    public AuthorizedContactLastNameEdited(): boolean {
        return this.original.AuthorizedContactLastName != this.newEntity.AuthorizedContactLastName;
    }

    public AuthorizedContactEmailEdited(): boolean {
        return this.original.AuthorizedContactEmail != this.newEntity.AuthorizedContactEmail;
    }

    public AuthorizedContactNoteEdited(): boolean {
        return this.original.AuthorizedContactNote != this.newEntity.AuthorizedContactNote;
    }


    public Edited(): boolean {

        if (this.FirstNameEdited())
            return true;

        if (this.LastNameEdited())
            return true;


        if (this.CompanyNameEdited())
            return true;


        if (this.EmailEdited())
            return true;

        if (this.PasswordEdited())
            return true;


        if (this.Phone1Edited())
            return true;


        if (this.Phone2Edited())
            return true;


        if (this.FaxEdited())
            return true;


        if (this.Address1Edited())
            return true;

        if (this.CityEdited())
            return true;

        if (this.HubspotVIDEdited())
            return true;

        if (this.StateEdited())
            return true;


        if (this.CountryEdited())
            return true;


        if (this.ZipCodeEdited())
            return true;


        if (this.LifeCycleStageEdited())
            return true;


        if (this.DefaultPayMethodEdited())
            return true;


        if (this.StatusEdited())
            return true;


        if (this.AdminNoteEdited())
            return true;

        if (this.AuthorizedContactEmailEdited())
            return true;

        if (this.AuthorizedContactFirstNameEdited())
            return true;

        if (this.AuthorizedContactLastNameEdited())
            return true;

        if (this.AuthorizedContactNoteEdited())
			return true;
			
		if (this.PreventAutomatedEmailEdited())
            return true;
			
        if (this.ExemptFromTaxEdited())
            return true;

        // not edited
        return false;

    }

    public SaveChanges(confirm: boolean = true, showResult: boolean = true, editNote: string = '') {

        if (this.Edited() == false)
            return;

        let request = this.GetMemberEditRequest();
        request.Note = editNote;
        this.SaveAction = this.api.MemberEdit(request);

        this.SaveChangesBase(true, true);
    }


    Load(id: number, showAfterLoad: boolean = true) {
        if (id < 1)
            return;

        this.LoadAction = this.api.MemberFull(id);

        let DataLoaded = this.OnDataLoaded.subscribe(() => {
            DataLoaded.unsubscribe();
            this.CloneDateFix();
            let options = {
                width: 1100,
                height: 800
            }
            this.DialogAction = this.dialogService.addDialog(MemberDetailsDialog, {
                memberManager: this
            }, options);
        });

        this.LoadBase();
    }


    private CloneDateFix(): void {

        // dates don't convert to Date so do it manual
        this.original.LastLogin = this.newEntity.LastLogin;
    }


    private GetMemberEditRequest(): MemberEditRequest {


        let request = new MemberEditRequest();
        request.ID = this.newEntity.ID;

        request.PreventAutomaticEmails = null; //Bind this to a checkbox.  Null means no change, 0 means unchecked, 1 means checked
        request.ExemptFromTax = null; //Bind this to a checkbox.  Null means no change, 0 means unchecked, 1 means checked

        if (this.FirstNameEdited())
            request.FirstName = this.newEntity.FirstName;
        else
            request.FirstName = null;

        if (this.LastNameEdited())
            request.LastName = this.newEntity.LastName;
        else
            request.LastName = null;

        if (this.CompanyNameEdited())
            request.CompanyName = this.newEntity.CompanyName;
        else
            request.CompanyName = null;

        if (this.EmailEdited())
            request.Email = this.newEntity.Email;
        else
            request.Email = null;

        if (this.PasswordEdited())
            request.Password = this.newEntity.Password;
        else
            request.Password = null;


        if (this.Phone1Edited())
            request.Phone1 = this.newEntity.Phone1.replace(/[^\d]/g, "");
        else
            request.Phone1 = null;


        if (this.Phone2Edited())
            request.Phone2 = this.newEntity.Phone2.replace(/[^\d]/g, "");
        else
            request.Phone2 = null;


        if (this.FaxEdited())
            request.Fax = this.newEntity.Fax;
        else
            request.Fax = null;


        if (this.Address1Edited())
            request.Address1 = this.newEntity.Address1;
        else
            request.Address1 = null;

        if (this.CityEdited())
            request.City = this.newEntity.City;
        else
            request.City = null;

        if (this.HubspotVIDEdited())
            request.HubspotVID = this.newEntity.HubspotVID;
        else
            request.HubspotVID = null;

        if (this.StateEdited())
            request.State = this.newEntity.State;
        else
            request.State = null;


        if (this.CountryEdited())
            request.Country = this.newEntity.Country;
        else
            request.Country = null;


        if (this.ZipCodeEdited())
            request.ZipCode = this.newEntity.ZipCode;
        else
            request.ZipCode = null;


        if (this.LifeCycleStageEdited())
            request.LifeCycleStage = this.newEntity.LifeCycleStage;
        else
            request.LifeCycleStage = null;


        if (this.DefaultPayMethodEdited())
            request.DefaultPayMethod = this.newEntity.DefaultPayMethod;
        else
            request.DefaultPayMethod = null;


        if (this.StatusEdited())
            request.Status = this.newEntity.Status;
        else
            request.Status = null;


        if (this.AdminNoteEdited())
            request.AdminNote = this.newEntity.AdminNote;
        else
            request.AdminNote = null;

        if (this.AuthorizedContactEmailEdited())
            request.AuthorizedContactEmail = this.newEntity.AuthorizedContactEmail;
        else
            request.AuthorizedContactEmail = null;

        if (this.AuthorizedContactFirstNameEdited())
            request.AuthorizedContactFirstName = this.newEntity.AuthorizedContactFirstName;
        else
            request.AuthorizedContactFirstName = null;

        if (this.AuthorizedContactLastNameEdited())
            request.AuthorizedContactLastName = this.newEntity.AuthorizedContactLastName;
        else
            request.AuthorizedContactLastName = null;


        if (this.AuthorizedContactNoteEdited())
            request.AuthorizedContactNote = this.newEntity.AuthorizedContactNote;
        else
			request.AuthorizedContactNote = null;
			
		if (this.PreventAutomatedEmailEdited())
            request.PreventAutomaticEmails = this.newEntity.PreventAutomaticEmails;
		else
            request.PreventAutomaticEmails = null;
			
        if (this.ExemptFromTaxEdited())
            request.ExemptFromTax = this.newEntity.ExemptFromTax;
		else
            request.ExemptFromTax = null;

		console.log(request);

        return request;

    }

}